<template>
  <v-main>
    <v-container fluid>
      <br />
      <v-btn class="mx-2" fab x-small color="primary" @click="$router.back()">
        <v-icon dark> mdi-arrow-left </v-icon>
      </v-btn>
      <!-- <v-row>
        <v-col md="10 offset-1">
          <v-row>
            <v-col md="10">
              <v-autocomplete
                ref="projects"
                dense
                v-model="form.project_id"
                :items="projectItems"
                label="Select Project"
                messages="Kindly Select any project"
                prepend-inner-icon="mdi-content-paste"
                outlined
                @change="getData()"
              ></v-autocomplete>
            </v-col>
            <v-col md="2">
              <router-link :to="`/dashboards/show-all`">Show All</router-link>
            </v-col>
          </v-row>
        </v-col>
      </v-row> -->
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <div v-else>
        <v-row v-for="(data, i) in treeData" :key="`data${i}`" class="pb-6">
          <v-col md="10 offset-1">
            <v-card elevation="6">
              <v-row class="px-5">
                <v-col md="6">
                  <v-row>
                    <v-col md="4">
                      <v-img
                        :src="`${mediaUrl + data.logo}`"
                        style="height: 90px; width: 100px; border-radius: 100%"
                      ></v-img>
                    </v-col>
                    <v-col md="8" class="mt-8">
                      Project Name : {{ data.project_name }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col md="6" class="mt-8">
                  <v-row>
                    <v-col md="6"
                      >Estimate start date : {{ data.estimated_date }}</v-col
                    >
                    <v-col md="6">Signature: {{ data.signature }}</v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="px-5">
                <v-col md="12">
                  <v-simple-table fixed-header>
                    <!-- :height="`${valueLists.length ? '370px' : ''}`" -->
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Sr No</th>
                          <th class="text-left">Category</th>
                          <th class="text-left">Allocated Budget</th>
                          <th class="text-left">Expected Service</th>
                          <th class="text-left">Total Service</th>
                          <th class="text-left">Total Spare Cost</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(category, i) in data.category"
                          :key="`category${i}`"
                        >
                          <td>{{ i + 1 }}</td>
                          <td>
                            {{ category.name }}
                          </td>
                          <td>
                            {{
                              category.allocated_budget
                                ? category.allocated_budget
                                : 0
                            }}
                          </td>
                          <td>
                            {{
                              category.total_expense
                                ? category.expected_service
                                : 0
                            }}
                          </td>
                          <td>
                            {{
                              category.total_expense
                                ? category.total_expense
                                : 0
                            }}
                          </td>
                          <td>
                            {{
                              category.total_spare_cost
                                ? category.total_spare_cost
                                : 0
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td></td>
                          <td></td>
                          <td style="font-weight: bold">
                            {{
                              data.grand_allocated_budget
                                ? data.grand_allocated_budget
                                : 0
                            }}
                          </td>
                          <td style="font-weight: bold">
                            {{
                              data.grand_expected_service
                                ? data.grand_expected_service
                                : 0
                            }}
                          </td>
                          <td style="font-weight: bold">
                            {{
                              data.grand_total_expense
                                ? data.grand_total_expense
                                : 0
                            }}
                          </td>
                          <td style="font-weight: bold">
                            {{
                              data.grand_total_spare_cost
                                ? data.grand_total_spare_cost
                                : 0
                            }}
                          </td>
                        </tr>
                      </tfoot>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <!-- <v-row>
        <v-col md="10 offset-1" v-if="categoryWiseChart.length">
          <v-card elevation="6">
            <v-card-title> Category wise chart</v-card-title>
            <v-card-text>
              <GChart
                type="ColumnChart"
                :data="categoryWiseChart"
                :options="columnchartOptions"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "ModulesPage",
  data() {
    return {
      form: {
        project_id: "",
        type: "",
      },
      // Tree data For treeview
      treeData: [],
      modules: [],
      categoryWiseChart: [],
      project: [],
      created_by_id: "",

      projectItems: [{ id: 0, text: "Select Project", value: "0" }],
      statusItems: [
        { id: "0", text: "Inprogress", value: 0 },
        { id: "1", text: "Waiting for spares", value: 1 },
        { id: "2", text: "Completed", value: 2 },
        { id: "3", text: "Waiting for Confirmation", value: 3 },
      ],

      isLoading: false,

      columnchartOptions: {
        annotations: {
          textStyle: {
            fontSize: 10,
          },
        },
        vAxis: {
          gridlines: {
            color: "transparent",
          },
          textStyle: {
            fontSize: 10,
          },
        },
        hAxis: {
          gridlines: {
            color: "transparent",
          },
        },
        legend: { position: "top", alignment: "center" },
      },
    };
  },
  mounted() {
    this.form.type = this.$route.query.type;
    if (this.$route.query.logged_in) {
      this.logged_in_as = this.$route.query.logged_in;
    }
    this.getData();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get(
        `modules/masters?category_type=${this.$route.query.type}`
      );
      masters = masters.data;

      masters.projects.forEach((project) => {
        if (project.type == "PROJECT") {
          this.projectItems.push({
            id: project.id,
            text: project.name,
            value: project.id,
          });
        }
      });
    },
    async getData() {
      this.modules = [];
      this.treeData = [];
      //   this.category = [];
      this.categoryWiseChart = [];
      this.isLoading = true;
      if (this.roleName == "Handler") {
        this.created_by_id = this.user.id;
      }
      //   let modules = [];
      let projects = await axios.get(
        `/projects?type=PROJECT&created_by_id=${this.created_by_id}`
      );
      this.projects = projects.data.data;
      //   modules = await axios.get(`modules?project_id=${this.form.project_id}`);
      //   this.modules = modules.data.data;
      this.projects.forEach((project) => {
        let m = {
          id: project.id,
          project_name: project.name,
          signature: project.signature,
          estimated_date: project.estimated_date,
          logo: project.logo,
          category: [],
          grand_total_expense: 0,
          grand_expected_service: 0,
          grand_total_spare_cost: 0,
          grand_allocated_budget: 0,
        };
        if (project.modules.length > 0) {
          project.modules.forEach((module) => {
            let newCategory = {
              name: "",
              children: [],
              total_expense: 0,
              expected_service: 0,
              total_spare_cost: 0,
              allocated_budget: module.allocated_budget,
            };
            let module_name = module.category.name;
            let total_expense = 0;
            let grand_total_expense = 0;
            newCategory.name = module_name;
            // if (module.sub_category) {
            //   module_name = module_name;
            // }
            // if (module.module_jobs.length > 0) {
            //   module_name = module_name;
            // }
            // console.log(m);

            if (module.module_jobs.length > 0) {
              module.module_jobs.forEach((moduleJob) => {
                let module_job_name = moduleJob.name;
                let expected_service = 0;
                if (moduleJob.total_cost) {
                  total_expense += parseInt(moduleJob.total_cost);

                  // module_job_name =
                  //   module_job_name + " || SEV: " + moduleJob.total_cost;
                  newCategory.total_expense = total_expense;
                }
                if (moduleJob.expected_cost) {
                  expected_service += parseInt(moduleJob.expected_cost);
                  // module_job_name =
                  //   module_job_name + " || SEV: " + moduleJob.total_cost;
                  newCategory.expected_service = expected_service;
                }

                if (moduleJob.module_job_spares.length) {
                  let total_spare_cost = 0;
                  moduleJob.module_job_spares.forEach((mjs) => {
                    total_spare_cost += parseInt(mjs.total_cost);
                  });
                  newCategory.total_spare_cost = total_spare_cost;
                }

                // m.category.push(newCategory);
                // console.log(newCategory);
                let mj = {
                  id: module.id + "-" + moduleJob.id,
                  name: module_job_name,
                  // title: this.title,
                  children: [],
                };
                /** Add if Any Sub jobs Present */
                moduleJob.module_jobs.forEach((smj) => {
                  let module_job_name = smj.name;
                  if (smj.total_cost) {
                    module_job_name =
                      module_job_name + " || SEV: " + smj.total_cost;
                  }
                  if (
                    smj.module_job_spares.length &&
                    smj.category.name != "SPARES"
                  ) {
                    let total_spare_cost = 0;
                    smj.module_job_spares.forEach((mjs) => {
                      total_spare_cost += parseInt(mjs.total_cost);
                    });
                    module_job_name =
                      module_job_name + " || SPA: " + total_spare_cost;
                  }
                  if (
                    smj.module_job_spares.length &&
                    smj.category.name == "SPARES"
                  ) {
                    let total_spare_cost = 0;
                    smj.module_job_spares.forEach((mjs) => {
                      total_spare_cost += parseInt(mjs.total_cost);
                    });
                    module_job_name = " SPA: " + total_spare_cost;
                  }
                  let child = {
                    id: module.id + "-" + moduleJob.id + "-" + smj.id,
                    name: module_job_name,

                    children: [],
                  };
                  mj.children.push(child);
                });
                // m.category.children.push(mj);
              });

              m.category.push(newCategory);
              let grand_total_expense = 0;
              let grand_expected_service = 0;
              let grand_total_spare_cost = 0;
              let grand_allocated_budget = 0;
              m.category.forEach((mm) => {
                grand_total_expense += parseInt(mm.total_expense);
                grand_expected_service += parseInt(mm.expected_service);
                grand_total_spare_cost += parseInt(mm.total_spare_cost);
                grand_allocated_budget += parseInt(mm.allocated_budget);

                console.log(grand_total_expense);
                m.grand_total_expense = grand_total_expense;
                m.grand_expected_service = grand_expected_service;
                m.grand_total_spare_cost = grand_total_spare_cost;
                m.grand_allocated_budget = grand_allocated_budget;
              });
            }
          });
        }
        this.treeData.push(m);
      });

      console.log(this.treeData);

      // let categoryWiseChart = [["Category", "Total Expense"]];
      // this.treeData.forEach((data) => {
      //   categoryWiseChart.push([data.name, data.total_expense]);
      // });
      // this.categoryWiseChart = categoryWiseChart;
      // console.log(this.treeData);
      this.isLoading = false;
    },
    capitalize(string) {
      if (string) {
        let capitalized_string =
          string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        return capitalized_string;
      }
    },
    calculated(selectedNode) {
      let total_cost = parseInt(selectedNode.qty) * parseInt(selectedNode.cost);
      if (selectedNode.discount_percentage) {
        total_cost =
          total_cost -
          (total_cost * parseInt(selectedNode.discount_percentage)) / 100;
      }
      if (selectedNode.discount_amount)
        total_cost = total_cost - parseInt(selectedNode.discount_amount);
      if (selectedNode.additional_percentage) {
        total_cost =
          total_cost +
          (total_cost * parseInt(selectedNode.additional_percentage)) / 100;
      }
      if (selectedNode.additional_amount)
        total_cost = total_cost + parseInt(selectedNode.additional_amount);
      selectedNode.total_cost = total_cost;
    },
    calculated_total(spare) {
      spare.total_cost =
        parseInt(spare.cost) + parseInt(spare.transportation_cost);
    },
  },
};
</script>
